import * as React from "react";
const BackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={39} height={39} x={0.5} y={0.5} stroke="#AEBBCB" rx={19.5} />
    <mask
      id="BackIcon"
      width={24}
      height={24}
      x={8}
      y={8}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M8 8h24v24H8z" />
    </mask>
    <g mask="url(#BackIcon)">
      <path
        fill="#656D76"
        d="m18 26-6-6 6-6 1.4 1.45L15.85 19H28v2H15.85l3.55 3.55L18 26Z"
      />
    </g>
  </svg>
);
export default BackIcon;
